"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const DynamicSchemaField_1 = require("./DynamicSchemaField");
class DynamicSchemaSection {
    constructor({ id, label, description, fields, meta, }) {
        this.toJSON = () => ({
            id: this.id,
            label: this.label,
            description: this.description,
            fields: this.fields.toJSON().map(field => field.toJSON()),
            meta: this.meta,
        });
        this.id = id;
        this.label = label;
        this.description = description;
        this.fields = fields;
        this.meta = meta;
    }
}
DynamicSchemaSection.fromJSON = (json) => {
    const { id, label, description, fields, meta } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (typeof description !== 'string')
        throw new Error('.description must be a string');
    if (!(Array.isArray(fields) || immutable_1.List.isList(fields)))
        throw new Error('.fields must be an array');
    if (meta != null && typeof meta !== 'object')
        throw new Error('.meta must be an undefined or object');
    return new DynamicSchemaSection({
        id,
        label,
        description,
        fields: immutable_1.List(fields).map(field => DynamicSchemaField_1.default.fromJSON(field)),
        meta,
    });
};
exports.default = DynamicSchemaSection;
